import { useEffect, useRef, useState } from "react";
import useOpenAIWebRTC from "./WebRTCSession";
import { API_AUTH_TYPES } from "../../../../../api/apiConstants";
import { MicrophoneIcon, StopIcon } from "@heroicons/react/outline";

export default function FloatingVoiceButton({ role = API_AUTH_TYPES.ADVISOR, conversationId = null }) {
    const [initializing, setInitializing] = useState(false);
    const [voice] = useState(() => localStorage.getItem('parabot_voice') || 'alloy');
    const { connect, disconnect, connected, error, remoteAudioRef } = useOpenAIWebRTC({ role, conversationId, voice });
    const audioContainerRef = useRef(null);

    useEffect(() => {
        if (remoteAudioRef.current && audioContainerRef.current) {
            const el = remoteAudioRef.current;
            if (!audioContainerRef.current.contains(el)) {
                audioContainerRef.current.appendChild(el);
            }
        }
    }, [remoteAudioRef, connected]);

    const handleToggle = async () => {
        if (!connected) {
            setInitializing(true);
            try {
                await connect();
            } finally {
                setInitializing(false);
            }
        } else {
            disconnect();
        }
    };

    return (
        <div className="absolute right-16 bottom-[50px] flex items-center gap-2">
            <button
                onClick={handleToggle}
                disabled={initializing}
                aria-label={connected ? 'Stop Voice' : 'Start Voice'}
                className={`rounded-full w-9 h-9 flex items-center justify-center shadow-2xl text-white ${connected ? 'bg-red-500 hover:bg-red-600' : 'bg-blue-600 hover:bg-blue-700'}`}
            >
                {connected ? <StopIcon className="w-5 h-5" /> : <MicrophoneIcon className="w-5 h-5" />}
            </button>
            {error && <span className="text-red-600 text-xs">{error}</span>}
            <div ref={audioContainerRef} />
        </div>
    );
}



